import { IReadOnlyAnswerResolver, NodeId } from '@zinnia/form-engine-sdk';
import { NodeIds } from '../nodeIds/nodeIds';

export function isPadPdfRequested(answerResolver: IReadOnlyAnswerResolver): boolean {
  const getAnswer = (nodeId: NodeId): unknown => answerResolver.usingNodeId().getAnswer(nodeId, {});

  return !!(
    getAnswer(NodeIds.padBranchNumber) &&
    getAnswer(NodeIds.padFinancialInstitutionNumber) &&
    getAnswer(NodeIds.padAccountNumber)
  );
}
